import { getLocale, useIntl } from 'umi';
import { useCallback, useMemo } from 'react';
import { LocaleType } from '@op/types/common';
import { DBO_V } from '@op/utils/format';

/**
 * 转换选项名称的中英文
 * @param props
 * @returns
 */
export default function useIntls() {
  const { formatMessage } = useIntl();

  const intl = useCallback(
    (data: string | { id: string }, ...args: any) => {
      const value = typeof data === 'object' ? data.id : data;

      if (DBO_V.is_empty(value)) return '';

      if (typeof value !== 'string') return value;

      return formatMessage({ id: value }, ...args);
    },
    [formatMessage],
  );

  const { selected, isEn } = useMemo(() => {
    const local: LocaleType = getLocale();

    return {
      selected: local,
      isEn: local === 'en-US',
    };
  }, [formatMessage]);

  const formatOptionsMessage = useCallback(
    (options: Array<{ text: string; [key: string]: any }>) =>
      options.map((item) => {
        const option = {
          ...item,
          text: intl(item.text),
        } as any;
        return option;
      }),
    [intl],
  );

  return {
    formatOptionsMessage,
    intl,
    intls: formatOptionsMessage,
    formatMessage: intl,
    selected,
    isEn,
  };
}
